define('SuiteDynamics.ShopByCategory.HorizontalCategories',
	[
		'SuiteDynamics.ShopByCategory.HorizontalCategories.View'
	],
	function (
		HorizontalCategoriesView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container) {
			var layout = container.getComponent('Layout');
			if(layout) {
				layout.addChildView('ShopByCategory', function() {
					return new HorizontalCategoriesView({
						container: container,
						application: layout.application
					});
				});
			}
		}
	};
});
